"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WitnessLayout = exports.WitnessLayoutFieldTags = exports.OtxStart = exports.Otx = exports.SighashAllOnly = exports.SighashAll = void 0;
const base_1 = require("@ckb-lumos/base");
const codec_1 = require("@ckb-lumos/codec");
const buildingPacket_1 = require("./buildingPacket");
exports.SighashAll = codec_1.molecule.table({
    seal: base_1.blockchain.Bytes,
    message: buildingPacket_1.Message,
}, ['seal', 'message']);
exports.SighashAllOnly = codec_1.molecule.table({
    seal: base_1.blockchain.Bytes,
}, ['seal']);
/**
 * Otx related are not implemented yet, so just placeholders.
 */
exports.Otx = codec_1.molecule.table({}, []);
exports.OtxStart = codec_1.molecule.table({}, []);
exports.WitnessLayoutFieldTags = {
    SighashAll: 4278190081,
    SighashAllOnly: 4278190082,
    Otx: 4278190083,
    OtxStart: 4278190084,
};
exports.WitnessLayout = codec_1.molecule.union({
    SighashAll: exports.SighashAll,
    SighashAllOnly: exports.SighashAllOnly,
    Otx: exports.Otx,
    OtxStart: exports.OtxStart,
}, exports.WitnessLayoutFieldTags);
//# sourceMappingURL=witnessLayout.js.map